import { render, staticRenderFns } from "./SettingsCustom.vue?vue&type=template&id=56528a1f&"
import script from "./SettingsCustom.vue?vue&type=script&lang=js&"
export * from "./SettingsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports